export default {
  namespaced: true,
  state: {
    editData: {
      faceImgPath: null,
      bankBranch: null,
      bankCardNumber: null,
      bankCode: null,
      name: null,
      onlineBankingPassword: null,
      onlineBankingPayPassword: null,
      onlineBankingUsername: null,
      phoneNumber: null,
      remark: null,
      id: null,
      userIdNo: null,
      accId: null,
      bankProvince: null,
      bankCity: null,
      buildNo: null,
      errorDescription: null,
      dispatchMode: 1, // 派单模式预设为手动
      isManualUser: null, // 是否为纯手动
      bankCardType: 1, // 银行卡类型
    },
    statusEditData: {
      id: null,
      canPay: true,
      canWithdraw: true,
      isAccError: true,
      isAccRiskControl: true,
      isSmsDelay: true,
      userEnable: true,
      isCheckOK: false,
      dispatchFrequencyType: null,
    },
    limitEditData: {
      dailyPaymentLimit: 0,
      dailyWithdrawalLimit: 0,
      enable: true,
      maxPaymentLimit: 0,
      maxWithdrawalLimit: 0,
      minPaymentLimit: 0,
      minWithdrawalLimit: 0,
      withdrawDayLimitFromBank: 0,
      payCd: 1,
      withdrawCd: 1,
      dispatchMode: null,
    },
    id: null,
    bankCardNumber: null,
    bankName: null,
    topupDialogVisible: false,
    statusDialogVisible: false,
    limitDialogVisible: false,
    dialogVisible: false,
  },
  mutations: {
    SET_STATE: (state, data) => {
      Object.keys(data).forEach(key => {
        state[key] = data[key]
      })
    },
    SET_EDIT: (state, data) => {
      Object.keys(data).forEach(key => {
        state.editData[key] = data[key]
      })
    },
    SET_STATUS_EDIT: (state, data) => {
      Object.keys(data).forEach(key => {
        state.statusEditData[key] = data[key]
      })
    },
    SET_EDIT_OBJ: (state, data) => {
      Object.keys(data).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(state.editData, key))
          state.editData[key] = data[key]
      })
    },
    SET_LIMIT_EDIT_OBJ: (state, data) => {
      Object.keys(data).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(state.limitEditData, key))
          state.limitEditData[key] = data[key]
      })
    },
    SET_STATUS_EDIT_OBJ: (state, data) => {
      Object.keys(data).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(state.statusEditData, key))
          state.statusEditData[key] = data[key]
      })
    },
    SET_DEFAULT: (state) => {
      Object.keys(state.editData).forEach(key => {
        state.editData[key] = null
      })
      Object.keys(state.statusEditData).forEach(key => {
        state.statusEditData[key] = true
      })
      state.editData.dispatchMode = 1; // 派单模式预设为手动
      state.editData.status = 1
      state.topupName = null
      state.topupId = null
      state.id = null
      state.bankCardNumber = null
      state.bankName = null
      state.editData.bankCardType = 1 // 银行卡类型
    },
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/account.js